import React, { Component } from "react";
import Header from "./header";
import SearchQuery from "./query_search_general";
import SearchOldItems from "./query_old_search_general";
import { MdArrowUpward } from "react-icons/md";
import ListTransactions from "./list_transactions";
import ListMovements from "./list_movements";
import ListItems from "./list_items";
import ListOldItems from "./list_old_items";
import momentTimeZone from "moment-timezone";
import DefaultMoment from "moment";
import loadInstructions from "./instructions";
import fixDate from "./fixdate";
import fixTime from "./fixtime";
import io from "socket.io-client";
import jwt_decode from "jwt-decode";
const url = "https://transacoes-api.all.com.br:3080";
const statusItem = require("../status.json");

let searchValue = "";
let status = [];

class QueryItems extends Component {
  state = {
    idEmployeeLogged: "",
    loading: true,
    transactions: [],
    movements: [],
    items: [],
    senders: [],
    filteredContent: false,
    selectedContentTransaction: [],
    selectedContentMovement: [],
    selectedContentItem: [],
    filter: "transactions",
    choose: "recent",
    oldItems: []
  };

  socket = io(url);

  async componentDidMount() {
    this.eventListenerSocket();
    loadInstructions(
      "Listagem dos malotes, movimentações e itens registrados."
    );
    await this.getUserLogged();
    this.getData();
  }

  getData = () => {
    this.getTransaction();
    this.getMovement();
    this.getItems();
    this.getSender();
  };

  eventListenerSocket = () => {
    this.socket.on("data", async () => {
      searchValue = "";
      await this.setState({
        selectedContentTransaction: [],
        selectedContentMovement: [],
        selectedContentItem: [],
        filteredContent: false,
        oldItems: []
      });
      this.getData();
    });
  };

  getUserLogged = async () => {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      await this.setState({
        idEmployeeLogged: decoded.id.toString()
      });
    } else
      this.setState({
        idEmployeeLogged: ""
      });
  };

  getTransaction = () => {
    fetch(`${url}/transacoes/${this.state.idEmployeeLogged}`)
      .then(response => response.json())
      .then(transaction => {
        if (transaction.length > 0) {
          let filteredTransaction = transaction.filter(
            transaction => transaction.result !== 0
          );
          this.setState({
            transactions: filteredTransaction,
            loading: false
          });
        } else this.setState({ transactions: [], loading: false });
      });
  };

  getMovement = () => {
    fetch(`${url}/movimentacoes/${this.state.idEmployeeLogged}`)
      .then(response => response.json())
      .then(movement => {
        if (movement.length > 0) {
          let filteredMovement = movement.filter(
            movement => movement.result !== 0
          );
          this.setState({ movements: filteredMovement, loading: false });
        } else {
          this.setState({ movements: [], loading: false });
        }
      });
  };

  getItems = () => {
    fetch(`${url}/itens/${this.state.idEmployeeLogged}`)
      .then(response => response.json())
      .then(item => {
        if (item.length > 0) {
          let filteredItem = item.filter(item => item.result !== 0);
          this.setState({ items: filteredItem, loading: false });
        } else {
          this.setState({ items: [], loading: false });
        }
      });
  };

  getSender = () => {
    fetch(`${url}/funcionarios`)
      .then(response => response.json())
      .then(sender => {
        if (sender)
          this.setState({
            senders: sender,
            loading: false
          });
        else this.setState({ senders: [], loading: false });
      });
  };

  handleSearch = value => {
    this.setState({
      selectedContentTransaction: [],
      selectedContentMovement: [],
      selectedContentItem: [],
      filteredContent: false
    });
    searchValue = value;
    this.handleFilter(this.state.filter);
    if (searchValue !== "") this.filterContentSearch(searchValue);
  };

  handleFilter = async e => {
    await this.setState({
      filter: e,
      selectedContentTransaction: [],
      selectedContentMovement: [],
      selectedContentItem: [],
      filteredContent: false
    });
    if (searchValue !== "") this.filterContentSearch(searchValue);
  };

  filterContentSearch = value => {
    let selectContent = [];
    if (this.state.filter === "transactions") {
      if (this.state.transactions.length > 0) {
        selectContent = this.state.transactions.filter(transaction => {
          return (
            transaction.id_transacao.toString().includes(value.toLowerCase()) ||
            (
              value.length === 2 &&
              DefaultMoment(transaction.created_at).format("DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 2 &&
              DefaultMoment(transaction.updated_at).format("DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 5 &&
              DefaultMoment(transaction.created_at).format("MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 5 &&
              DefaultMoment(transaction.updated_at).format("MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 10 &&
              DefaultMoment(transaction.created_at).format("YYYY/MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 10 &&
              DefaultMoment(transaction.updated_at).format("YYYY/MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 2 &&
              momentTimeZone(transaction.created_at)
                .tz("UTC")
                .format("HH")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 2 &&
              momentTimeZone(transaction.updated_at)
                .tz("UTC")
                .format("HH")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 5 &&
              momentTimeZone(transaction.created_at)
                .tz("UTC")
                .format("HH:mm")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 5 &&
              momentTimeZone(transaction.updated_at)
                .tz("UTC")
                .format("HH:mm")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 8 &&
              momentTimeZone(transaction.created_at)
                .tz("UTC")
                .format("HH:mm:ss")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 8 &&
              momentTimeZone(transaction.updated_at)
                .tz("UTC")
                .format("HH:mm:ss")
            )
              .toString()
              .includes(fixTime(value)) ||
            (value.toLowerCase() === "ativo" &&
              transaction.status.toLowerCase() === "ativa") ||
            (value.toLowerCase() === "pendente" &&
              transaction.status.toLowerCase() === "pendente") ||
            (value.toLowerCase() === "concluido" &&
              transaction.status.toLowerCase() === "concluida") ||
            transaction.status.toLowerCase().includes(value.toLowerCase())
          );
        });
        this.setState({
          selectedContentTransaction:
            selectContent.length > 0 ? selectContent : false,
          filteredContent: true
        });
      }
    } else if (this.state.filter === "movements") {
      let sender = [],
        count = 0;
      if (this.state.movements.length > 0) {
        sender = this.state.senders.filter(sender =>
          sender.usuario
            .toLowerCase()
            .replace(".", " ")
            .includes(value.toLowerCase())
        );
        if (sender.length > 1) {
          count = sender.length;
        } else count = 0;
        selectContent = this.state.movements.filter(movement => {
          return (
            movement.id_movimentacao.toString().includes(value.toLowerCase()) ||
            (
              value.length === 2 &&
              DefaultMoment(movement.created_at).format("DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 2 &&
              DefaultMoment(movement.updated_at).format("DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 5 &&
              DefaultMoment(movement.created_at).format("MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 5 &&
              DefaultMoment(movement.updated_at).format("MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 10 &&
              DefaultMoment(movement.created_at).format("YYYY/MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 10 &&
              DefaultMoment(movement.updated_at).format("YYYY/MM/DD")
            )
              .toString()
              .includes(fixDate(value)) ||
            (
              value.length === 2 &&
              momentTimeZone(movement.created_at)
                .tz("UTC")
                .format("HH")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 2 &&
              momentTimeZone(movement.updated_at)
                .tz("UTC")
                .format("HH")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 5 &&
              momentTimeZone(movement.created_at)
                .tz("UTC")
                .format("HH:mm")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 5 &&
              momentTimeZone(movement.updated_at)
                .tz("UTC")
                .format("HH:mm")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 8 &&
              momentTimeZone(movement.created_at)
                .tz("UTC")
                .format("HH:mm:ss")
            )
              .toString()
              .includes(fixTime(value)) ||
            (
              value.length === 8 &&
              momentTimeZone(movement.updated_at)
                .tz("UTC")
                .format("HH:mm:ss")
            )
              .toString()
              .includes(fixTime(value)) ||
            movement.status.toLowerCase().includes(value.toLowerCase()) ||
            movement.id_item.toString().includes(value.toLowerCase()) ||
            movement.id_transacao.toString().includes(value.toLowerCase()) ||
            (sender.length > 0
              ? value.length === count
                ? movement.id_remetente === sender[0].id
                : movement.id_remetente === sender[0].id
              : false) ||
            (sender.length > 0
              ? value.length === count
                ? movement.id_destinatario === sender[0].id
                : movement.id_destinatario === sender[0].id
              : false)
          );
        });
        this.setState({
          selectedContentMovement:
            selectContent.length > 0 ? selectContent : false,
          filteredContent: true
        });
      }
    } else if (this.state.filter === "items") {
      if (this.state.items.length > 0)
        status = statusItem.filter(status =>
          status.status.toLowerCase().includes(value.toLowerCase())
        );
      selectContent = this.state.items.filter(item => {
        return (
          item.id_item.toString().includes(value.toLowerCase()) ||
          item.id_movimentacao.toString().includes(value.toLowerCase()) ||
          item.tipo.toLowerCase().includes(value.toLowerCase()) ||
          item.destino
            .toLowerCase()
            .replace(".", " ")
            .includes(value.toLowerCase()) ||
          item.descricao.toLowerCase().includes(value.toLowerCase()) ||
          item.patrimonio.toString().includes(value) ||
          item.observacao.toLowerCase().includes(value.toLowerCase()) ||
          (status.length > 0 && item.status === status[0].id_status)
        );
      });
      this.setState({
        selectedContentItem: selectContent.length > 0 ? selectContent : false,
        filteredContent: true
      });
    } else {
      this.setState({
        filteredContent: false
      });
    }
  };

  scrollTop = () => {
    window.scrollTo(0, 0);
  };

  activeChoose = async choose => {
    if (choose === "recent")
      await this.setState({ oldItems: [], filter: "transactions" });
    else {
      await this.setState({
        selectedContentTransaction: [],
        selectedContentMovement: [],
        selectedContentItem: [],
        filteredContent: false
      });
    }
    searchValue = "";
    await this.setState({ choose });
  };

  handleSearchOldItems = async value => {
    if (value.length > 2) this.setState({ loading: true });
    else this.setState({ oldItems: [], loading: false });
    if (value.length > 2) {
      await fetch(`${url}/antigos?search=${value}`)
        .then(response => response.json())
        .then(oldItem => {
          if (oldItem)
            this.setState({
              oldItems: oldItem,
              loading: false
            });
          else this.setState({ oldItems: [], loading: false });
        });
    }
  };

  render() {
    const {
      transactions,
      movements,
      items,
      senders,
      selectedContentTransaction,
      selectedContentMovement,
      selectedContentItem,
      filter,
      choose,
      oldItems,
      loading
    } = this.state;
    return (
      <React.Fragment>
        <Header
          title={"Consulta"}
          activeNavContent={false}
          activeChoose={choose => this.activeChoose(choose)}
        />

        <div
          className="search"
          style={{
            float: "center",
            margin: "auto",
            width: "100%",
            display: "block",
            position: "fixed",
            zIndex: "10",
            marginTop: "40px"
          }}
        >
          {choose === "recent" ? (
            <SearchQuery
              handleFilter={e => this.handleFilter(e)}
              handleSearch={e => this.handleSearch(e)}
            />
          ) : (
            <SearchOldItems
              handleSearchOldItems={e => this.handleSearchOldItems(e)}
            />
          )}
        </div>

        {loading && (
          <div
            className="preloader-wrapper big active"
            style={{
              display: "block",
              margin: "auto",
              float: "center",
              marginTop: "210px"
            }}
          >
            <div className="spinner-layer spinner-red-only">
              <div className="circle-clipper left">
                <div className="circle" />
              </div>
              <div className="gap-patch">
                <div className="circle" />
              </div>
              <div className="circle-clipper right">
                <div className="circle" />
              </div>
            </div>
          </div>
        )}
        {choose === "recent"
          ? !loading && (
              <center>
                {filter.includes("transactions") && (
                  <ListTransactions
                    selectedContent={
                      selectedContentTransaction.length === 0
                        ? true
                        : selectedContentTransaction
                    }
                    filter={filter && filter}
                    transactions={transactions.length > 0 && transactions}
                  />
                )}
                {filter.includes("movements") && (
                  <ListMovements
                    selectedContent={
                      selectedContentMovement.length === 0
                        ? true
                        : selectedContentMovement
                    }
                    filter={filter && filter}
                    transactions={transactions.length > 0 && transactions}
                    movements={movements.length > 0 && movements}
                    senders={senders.length > 0 && senders}
                  />
                )}
                {filter.includes("items") && (
                  <ListItems
                    selectedContent={
                      selectedContentItem.length === 0
                        ? true
                        : selectedContentItem
                    }
                    filter={filter && filter}
                    items={items.length > 0 && items}
                  />
                )}
                <a
                  disabled={this.state.transactions.length > 0 ? false : true}
                  href="#up"
                  className="btn-floating btn-large halfway-fab waves-effect waves-light"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "7px",
                    backgroundColor: "#357ae8"
                  }}
                  onClick={() => this.scrollTop()}
                >
                  <i className="material-icons">
                    <MdArrowUpward />
                  </i>
                </a>
              </center>
            )
          : !loading && (
              <center>
                <ListOldItems items={oldItems.length > 0 && oldItems} />
                <a
                  disabled={this.state.oldItems.length > 0 ? false : true}
                  href="#up"
                  className="btn-floating btn-large halfway-fab waves-effect waves-light"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "7px",
                    backgroundColor: "#357ae8"
                  }}
                  onClick={() => this.scrollTop()}
                >
                  <i className="material-icons">
                    <MdArrowUpward />
                  </i>
                </a>
              </center>
            )}
      </React.Fragment>
    );
  }
}

export default QueryItems;
